import type { PixelEvent } from '@/events';

import type { IEventQueue } from '../../queue/types';
import type { PipelineStage } from '../types';

export class EnqueueStage implements PipelineStage {
  readonly name = 'enqueue';

  private readonly queue: IEventQueue;

  constructor(queue: IEventQueue) {
    this.queue = queue;
  }

  process(event: PixelEvent): PixelEvent | null {
    this.queue.enqueue(event);
    return event;
  }
}
